import React, { useEffect } from "react";
import { trackEvent } from "@leafly-com/web-utils";

import { Strain } from "custom-types/Strain";

import Image from "../Image";

const LEAFLY_SWAG_STRAIN_TEES: Record<string, string> = {
  "animal-mints":
    "https://www.leaflyswag.com/storeitem.html?vid=20221005163&iid=77604&utm_source=LeaflyWebsite&utm_medium=LeaflyMarketing&utm_campaign=StrainPageMarketing&utm_content=AnimalMints",
  "bubba-kush":
    "https://www.leaflyswag.com/storeitem.html?vid=20221005163&iid=77599&utm_source=LeaflyWebsite&utm_medium=LeaflyMarketing&utm_campaign=StrainPageMarketing&utm_content=BubbaKush",
  chocolope:
    "https://www.leaflyswag.com/storeitem.html?vid=20221005163&iid=77615&utm_source=LeaflyWebsite&utm_medium=LeaflyMarketing&utm_campaign=StrainPageMarketing&utm_content=Chocolope",
  "granddaddy-purple":
    "https://www.leaflyswag.com/storeitem.html?vid=20221005163&iid=77607&utm_source=LeaflyWebsite&utm_medium=LeaflyMarketing&utm_campaign=StrainPageMarketing&utm_content=GranddaddyPurple",
  jealousy:
    "https://www.leaflyswag.com/storeitem.html?vid=20221005163&iid=77603&utm_source=LeaflyWebsite&utm_medium=LeaflyMarketing&utm_campaign=StrainPageMarketing&utm_content=Jealousy",
  "northern-lights":
    "https://www.leaflyswag.com/storeitem.html?vid=20221005163&iid=77602&utm_source=LeaflyWebsite&utm_medium=LeaflyMarketing&utm_campaign=StrainPageMarketing&utm_content=NorthernLights",
  "pineapple-express":
    "https://www.leaflyswag.com/storeitem.html?vid=20221005163&iid=77614&utm_source=LeaflyWebsite&utm_medium=LeaflyMarketing&utm_campaign=StrainPageMarketing&utm_content=PineappleExpress",
  "purple-punch":
    "https://www.leaflyswag.com/storeitem.html?vid=20221005163&iid=77616&utm_source=LeaflyWebsite&utm_medium=LeaflyMarketing&utm_campaign=StrainPageMarketing&utm_content=PurplePunch",
  "sour-diesel":
    "https://www.leaflyswag.com/storeitem.html?vid=20221005163&iid=77609&utm_source=LeaflyWebsite&utm_medium=LeaflyMarketing&utm_campaign=StrainPageMarketing&utm_content=SourDiesel",
  "strawberry-cough":
    "https://www.leaflyswag.com/storeitem.html?vid=20221005163&iid=77600&utm_source=LeaflyWebsite&utm_medium=LeaflyMarketing&utm_campaign=StrainPageMarketing&utm_content=StrawberryCough",
  "white-widow":
    "https://www.leaflyswag.com/storeitem.html?vid=20221005163&iid=77612&utm_source=LeaflyWebsite&utm_medium=LeaflyMarketing&utm_campaign=StrainPageMarketing&utm_content=WhiteWidow",
};

type StrainTeeSwagProps = {
  strain: Strain;
};

const StrainTeeSwag = ({ strain }: StrainTeeSwagProps): JSX.Element | null => {
  useEffect(() => {
    if (LEAFLY_SWAG_STRAIN_TEES[strain.slug]) {
      trackEvent("Swag CTA", "Impression", strain.name);
    }
  }, [strain.slug]);

  if (!LEAFLY_SWAG_STRAIN_TEES[strain.slug]) {
    return null;
  }

  const imgClickHandler = () => {
    trackEvent("Swag CTA", "Click", strain.name);
  };

  return (
    <div className="mt-4" data-testid="strain-tee-swag-container">
      <a
        href={`${LEAFLY_SWAG_STRAIN_TEES[strain.slug]}`}
        onClick={imgClickHandler}
        data-testid="strain-tee-swag-link"
      >
        <Image
          sizes={[323]}
          src={`https://leafly-public.imgix.net/web-home/leafly-swag/${strain.slug}.jpg`}
          alt={`Shop for official Leafly merch on leaflyswag.com. Grab your ${strain.name} strain tee today!`}
          imageClass="rounded"
          disableLazyLoad
        />
      </a>
    </div>
  );
};

export default StrainTeeSwag;
